import React from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
// import TasksAllocations from "./TasksAllocations";
import MyLeaveRequest from "./MyLeaveRequest";
import Pagenotfound from "../../components/common/Pagenotfound";
import { useSelector } from "react-redux";
import MonthlyReport from "./MonthlyReport";
import AllLeaveRequest from "./AllLeaveRequest";

function ManageLeave() {
  const location = useLocation();
  const isActiveTab = (path) => location.pathname.includes(path);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user;
  const role = login_user_role;
 
  return (
    <div className="bg-white p-3 detailpage">
      {/* Nav Tabs */}
    <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="My-Leave-Request"
            className={`nav-link ${isActiveTab("My-Leave-Request") ? "active" : ""}`}
          >
           My Leave Request
          </Link>
        </li> 
        {(role === 'ADMIN' || role === 'MANAGER') && (
         <li className="nav-item pe-4" role="presentation">
          <Link
            to="All-Leave-Request"
            className={`nav-link ${isActiveTab("All-Leave-Request") ? "active" : ""}`}
          >
           All Leave Request
          </Link>
        </li>      
        )}  
          <li className="nav-item pe-4" role="presentation">
            <Link
              to="Monthly-Report"
              className={`nav-link ${
                isActiveTab("Monthly-Report") ? "active" : ""
              }`}
            >
              Monthly Report
            </Link>
          </li>
     
      </ul>

      {/* Tab Content */}
      <div className="tab-content" id="myTabContent">
        <Routes>
          <Route index element={<Navigate to="My-Leave-Request" replace />} />
          <Route path="My-Leave-Request" element={<MyLeaveRequest />} />
          <Route path="All-Leave-Request" element={<AllLeaveRequest />} />
          <Route path="Monthly-Report" element={<MonthlyReport />} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
      </div>
    </div>
  );
}

export default ManageLeave;
